import { env } from '@configuration/env';
import { createRouter, createWebHistory } from 'vue-router';

const router = createRouter({
  history: createWebHistory(env.BASE_URL),
  routes: [],
  scrollBehavior: (_, __, savedPosition) => savedPosition ?? { top: 0, left: 0 },
});

export default router;
